import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { configuration, extAccessLog, extAccessSearchModel } from 'src/app/archive-external-access/models';
import { keyValuePair } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})

export class ArchiveService {
  constructor(private http: HttpService, private logger: NGXLogger) { }

  public extAccessSearchLog(model:extAccessSearchModel): Observable<Array<extAccessLog>> {
    let body = JSON.stringify(model);
    return this.http.postToApi(`/Archive/ExternalPlayback/SearchLog`, body);
  }

  public cancelExtAccess(id: number,recipient:string,recordings:string[]): Observable<boolean> {
    let body = JSON.stringify({id,recipient,recordings});
    return this.http.postToApi(`/Archive/ExternalPlayback/CancelExtPlayback`, body);
  }

  public getExtAccessConfig(): Observable<configuration> {
    return this.http.getFromApi(`/Archive/ExternalPlayback/Config`);
  }
  public getSupportedLanguages(): Observable<keyValuePair[]> {
    return this.http.getFromApi(`/Archive/ExternalPlayback/SupportedLanguages`);
  }

  public saveExtAccessConfig(config: configuration,file: File): Observable<any> {
    const formData: FormData = new FormData();
    if(file){
      formData.append("file", file, file.name);
    }
    formData.append("model", JSON.stringify(config));
    return this.http.postFormDataToApi(`/Archive/ExternalPlayback/Config`, formData);
  }

  getArchiveServiceConfigLogo(): Observable<Blob> {
    return this.http.getBlobFromApi(`/Archive/ExternalPlayback/Logo`);
  }
}
